import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WordsThatTouchTheHeart from "./sections/WordsThatTouchTheHeart";
import HerzlichWillkommen from "./sections/HerzlichWillkommen";
import HealingMethods from "./sections/HealingMethods";
import StimmenUnsererPartner from "./sections/StimmenUnsererPartner";
import LetItShine from "./sections/LetItShine";
import InteractiveCards from "./sections/InteractiveCards";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WordsThatTouchTheHeart />
      <HerzlichWillkommen />
      <HealingMethods />
      <InteractiveCards />
      <StimmenUnsererPartner />
      <LetItShine />
      <Footer />
    </div>;
}